module.exports = __webpack_public_path__ + "static/media/s_3.45ac267f.mp3";